import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { inventoryStore } from '../stores/InventoryStore';
const InventoryDialog = observer(() => {
    const [formData, setFormData] = useState({
        name: '',
        active: true
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (inventoryStore.isEditing && inventoryStore.selectedInventory) {
            setFormData({
                name: inventoryStore.selectedInventory.name,
                active: inventoryStore.selectedInventory.active
            });
        }
        else {
            setFormData({
                name: '',
                active: true
            });
        }
        setErrors({});
    }, [inventoryStore.isDialogOpen, inventoryStore.isEditing, inventoryStore.selectedInventory]);
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = 'Inventory name is required';
        }
        else if (formData.name.trim().length < 2) {
            newErrors.name = 'Inventory name must be at least 2 characters long';
        }
        else if (formData.name.trim().length > 100) {
            newErrors.name = 'Inventory name cannot exceed 100 characters';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        try {
            if (inventoryStore.isEditing && inventoryStore.selectedInventory) {
                await inventoryStore.updateInventory(inventoryStore.selectedInventory.id, formData);
            }
            else {
                await inventoryStore.createInventory(formData);
            }
            inventoryStore.closeDialog();
        }
        catch (error) {
            // Error is handled by the store
        }
    };
    const handleClose = () => {
        inventoryStore.closeDialog();
    };
    return (_jsxs(Modal, { show: inventoryStore.isDialogOpen, onHide: handleClose, size: "lg", children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: inventoryStore.isEditing ? 'Edit Inventory' : 'Add New Inventory' }) }), _jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs(Modal.Body, { children: [inventoryStore.hasError && (_jsx(Alert, { variant: "danger", className: "mb-3", children: inventoryStore.error })), _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Inventory Name *" }), _jsx(Form.Control, { type: "text", name: "name", value: formData.name, onChange: handleInputChange, isInvalid: !!errors.name, placeholder: "Enter inventory name", disabled: inventoryStore.isLoading }), _jsx(Form.Control.Feedback, { type: "invalid", children: errors.name })] }), _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Check, { type: "checkbox", name: "active", label: "Active", checked: formData.active, onChange: handleInputChange, disabled: inventoryStore.isLoading }), _jsx(Form.Text, { className: "text-muted", children: "Active inventories are available for use" })] })] }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "secondary", onClick: handleClose, disabled: inventoryStore.isLoading, className: "btn-touch w-mobile-100", children: "Cancel" }), _jsxs(Button, { variant: "primary", type: "submit", disabled: inventoryStore.isLoading, className: "btn-touch w-mobile-100", children: [inventoryStore.isLoading && (_jsx(Spinner, { animation: "border", size: "sm", className: "me-2" })), inventoryStore.isEditing ? 'Update' : 'Create'] })] })] })] }));
});
export default InventoryDialog;
